import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";
import {faBars} from "@fortawesome/pro-regular-svg-icons/faBars";
import {faSearch} from "@fortawesome/pro-light-svg-icons/faSearch";
import {faWebcam} from "@fortawesome/pro-solid-svg-icons/faWebcam";
import {faCrown} from "@fortawesome/pro-solid-svg-icons/faCrown";
import {faCoins} from "@fortawesome/pro-light-svg-icons/faCoins";
import {faPlayCircle} from "@fortawesome/pro-regular-svg-icons/faPlayCircle";
import {faHeart} from "@fortawesome/pro-solid-svg-icons/faHeart";
import {faHeart as faHeartLight} from "@fortawesome/pro-light-svg-icons/faHeart";
import {faAngleLeft} from "@fortawesome/pro-light-svg-icons/faAngleLeft";
import {faAngleRight} from "@fortawesome/pro-light-svg-icons/faAngleRight";
import {faCommentAlt} from "@fortawesome/pro-solid-svg-icons/faCommentAlt";
import {faCommentsAlt} from "@fortawesome/pro-solid-svg-icons/faCommentsAlt";
import {faThumbsUp} from "@fortawesome/pro-solid-svg-icons/faThumbsUp";
import {faVolumeUp} from "@fortawesome/pro-solid-svg-icons/faVolumeUp";
import {faVolumeMute} from "@fortawesome/pro-solid-svg-icons/faVolumeMute";
import {faVolume} from "@fortawesome/pro-solid-svg-icons/faVolume";
import {faTimes} from "@fortawesome/pro-regular-svg-icons/faTimes";

import {dom, library} from "@fortawesome/fontawesome-svg-core";

export function FontAwesomeLoader() {
	// @ts-ignore
	library.add(faUser, faBars, faSearch, faWebcam, faCrown, faCoins, faPlayCircle,
				faHeart, faAngleRight, faAngleLeft, faCommentAlt, faCommentsAlt, faHeartLight,
				faThumbsUp, faVolumeUp, faVolumeMute, faVolume, faTimes);
	dom.watch()
}
